<template>
  <td class="data-grid__cell" ref="cell">
    <slot />
  </td>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  name: 'cell',
  props: ['gridId', 'rowKey', 'cellKey', 'options'],
  methods: {
    highlight(gridId, rowKey, cellKey) {
      if (
        this.gridId !== gridId ||
        this.rowKey !== rowKey ||
        this.cellKey !== cellKey
      )
        return

      $(this.$refs.cell).addClass('item-highlight')

      setTimeout(() => {
        $(this.$refs.cell).removeClass('item-highlight')
      }, 2000)
    },
  },
  created() {
    eventBus.$on('dgCellChanged', this.highlight)
  },
  beforeDestroy() {
    eventBus.$off('dgCellChanged', this.highlight)
  }
}
</script>

<style lang="scss">
@keyframes yellowfade {
  from {
    background-color: #ffd600;
    border-radius: 5px;
  }
  to {
    background: transparent;
    border-radius: 5px;
  }
}

.data-grid__cell.item-highlight {
  > *,
  input,
  textarea {
    animation: yellowfade 2s;
  }
}
</style>
